import {Component, OnInit, NgModule, Input, Output, EventEmitter, ViewChild} from '@angular/core';

@Component({
    selector: 'app-topdown-adjustment-common',
    templateUrl: './topdown-adjustment-common.component.html',
    styleUrls: ['./topdown-adjustment-common.component.scss'],
    standalone: false
})
export class TopdownAdjustmentCommonComponent implements OnInit {
	defaultForecastElemntName: string;
	defaultSplitbase: string;
	constructor(private forecastService: ForecastService) {}

	elementName = 'elementName';
	elementCaption = '';
	title = '';
	captionValue = '';
	// prams
	@Input() selectedItemForecastElement = '';
	@Input() selectedItemUnitElement = '';
	//event
	@Output() searchDataEvent = new EventEmitter<TopdownAddAdjustmentSelection>();
	@Output() saveDataEvent = new EventEmitter<true>();

	forecastElementsDdlData: DdlData[];
	unitElementsDdlData: DdlData[];
	splitBasesDdlData: ForecastAjstSplitBaseData[];
	topDownData: TopdownAdjustmentParam = new TopdownAdjustmentParam();

	defaultElement: string = null;
	public numberFormat = '#,##0.##';
	public numberTitle = 'Quantity';
	//https://vicmans.com/demos/ng-toggle-button/
	showTotalQuantity: boolean = true;
	checkedTopdown: boolean = true;
	enableEditOption: boolean = true;

	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild('dxForecastElemntName', {static: false}) dxForecastElemntName: DxSelectBoxComponent;
	@ViewChild('dxForecastUnitMeasure', {static: false}) dxForecastUnitMeasure: DxSelectBoxComponent;
	@ViewChild('dxSplitbase', {static: false}) dxSplitbase: DxSelectBoxComponent;

	ngOnInit() {
		this.forecastService.getTopdownAdjustmentLoadDataNew(
			'LoadNewOption',
			{
				showLoadingIndicator: false,
			}
		).subscribe(
			{
				next: (response) => {
					this.forecastElementsDdlData = response.forecastElements;
					this.unitElementsDdlData = response.unitElements;
					this.splitBasesDdlData = response.splitBases;
					response.defaultElements.forEach((element) => {
						if (element.title === 'TopdownForecastElementDefaultSelection') {
							let item = this.forecastElementsDdlData.filter((x) => x.value === element.value);
							if (item.length > 0) {
								this.dxForecastElemntName.value = item[0].value;
								this.defaultForecastElemntName= item[0].value;
							}
						}
						if (element.title === 'TopdownSplitBaseDefaultSelection') {
							let item1 = this.splitBasesDdlData.filter((x) => x.elementName === element.value);
							if (item1.length > 0) {
								this.dxSplitbase.value = item1[0].elementName;
								this.defaultSplitbase= item1[0].elementName;
							}
						}
					});

					this.searchData('');
				}
			}
		);
	}

	forecastAjstListData: any = [];
	@Input() set dataSource(arr: any) {
		this.forecastAjstListData = arr;
	}

	forecastCaption: ForecastChartCaption[] = [];
	@Input() set srcCaption(arr: ForecastChartCaption[]) {
		this.forecastCaption = arr;
	}

	topdownSearch: TopdownAdjustmentParamNew = new TopdownAdjustmentParamNew();
	@Input() set datatopdownSearch(arr: TopdownAdjustmentParamNew) {
		this.topdownSearch = arr;
	}
	onSplitBasechanged(event) {
		if(this.defaultSplitbase != event.selectedItem.elementName){
			this.searchData('');
			this.defaultSplitbase = event.selectedItem.elementName;
		}
	}
	onforecastElementchanged(event) {
		if(this.defaultForecastElemntName != event.selectedItem.value){
			this.searchData('');
			this.defaultForecastElemntName = event.selectedItem.value;
		}
	}

	onFocusedCellChanging(e: any) {
		const dataGrid = e.component;
		const visibleRows = dataGrid.getDataSource().store()._array;
		const visibleColumns = dataGrid.getVisibleColumns();
		const currentRowIndex = e.prevRowIndex;
		const currentColumnIndex = e.prevColumnIndex;

		let nextRowIndex = currentRowIndex + 1;
		let nextColumnIndex = currentColumnIndex;

		if (nextRowIndex >= visibleRows.length) {
		  nextRowIndex = 0;
		  nextColumnIndex = this.getNextEditableColumnIndex(visibleColumns, currentColumnIndex);
		}

		if (nextColumnIndex !== -1) {
		  e.newRowIndex = nextRowIndex;
		  e.newColumnIndex = nextColumnIndex;
		} else {
		  e.cancel = true;
		}
	  }

	  getNextEditableColumnIndex(columns: any[], currentColumnIndex: number): number {
		for (let i = currentColumnIndex + 1; i < columns.length; i++) {
		  if (columns[i].allowEditing) {
			return i;
		  }
		}
		for (let i = 0; i <= currentColumnIndex; i++) {
			if (columns[i].allowEditing) {
			  return i;
			}
		  }
		return -1;
	  }


	searchData(event) {
		let obj: TopdownAddAdjustmentSelection = new TopdownAddAdjustmentSelection();
		obj.forecastElemntNameValue = '';
		obj.forecastUnitMeasureValue = '';
		obj.forecastElemntNameText = '';
		obj.forecastUnitMeasureText = '';
		obj.forecastBaseSplitText = '';
		obj.forecastBaseSplitValue = '';

		if (this.dxForecastElemntName) {
			obj.forecastElemntNameValue = this.dxForecastElemntName.value;
			obj.forecastElemntNameText = this.dxForecastElemntName.text;
		}

		if (this.dxForecastUnitMeasure) {
			obj.forecastUnitMeasureValue = this.dxForecastUnitMeasure.value;
			obj.forecastUnitMeasureText = this.dxForecastUnitMeasure.text;
		}

		if (this.dxSplitbase) {
			obj.forecastBaseSplitText = this.dxSplitbase.text;
			obj.forecastBaseSplitValue = this.dxSplitbase.value;
		}

		let item = this.forecastElementsDdlData.filter((x) => x.value === this.dxForecastElemntName.value);
		this.enableEditOption = true;
		if (item.length > 0) {
			if (item[0].extra === '0') {
				this.enableEditOption = false;
			}
		}

		this.searchDataEvent.emit(obj);
	}

	updateDataValueChange(data, action) {
		if (data && action) {
			/* getting index for both for update */
			let updateforecastAjstListData = this.forecastAjstListData.find((x) => x.period === data.period);
			let indexUpdate = this.forecastAjstListData.indexOf(updateforecastAjstListData);
			if (this.forecastAjstListData && this.forecastAjstListData[indexUpdate]) {
				if (action === 'EditAjtTemplate') {
					if (data.ajestValue) {
						this.forecastAjstListData[indexUpdate].removeAjestValue = false;
					}
				} else if (action === 'EditRevAjtTemplate') {
					if (data.removeAjestValue && data.removeAjestValue) {
						this.forecastAjstListData[indexUpdate].ajestValue = null;
					}
				}
			}
		}
	}

	resetFilters() {
		this.dxForecastUnitMeasure.value = null;
		this.forecastAjstListData = [];
	}

	saveAllChanges() {
		if (this.topdownSearch && this.topdownSearch.forecastItem.length > 0) {
			let data: UpdateTopDown = new UpdateTopDown();
			data.forecastElemntName = this.topdownSearch.forecastElemntName;
			data.forecastSplitBase = this.topdownSearch.forecastSplitBase;
			data.forecastItem = this.topdownSearch.forecastItem;
			data.UnitOfMeasureName = this.selectedItemUnitElement;
			data.topdownAjst = [];
			for (let i = 0; i < this.forecastAjstListData.length; i++) {
				if (this.forecastAjstListData != null) {
					if (!this.checkedTopdown) {
						if (this.forecastAjstListData[i].ajestValue != null && this.forecastAjstListData[i].ajestValue != undefined) {
							data.topdownAjst.push({
								period: this.forecastAjstListData[i].period,
								ajestValue: this.forecastAjstListData[i].ajestValue * this.forecastAjstListData[i].totalForecastSum,
								removeAjestValue: this.forecastAjstListData[i].removeAjestValue,
								SpiltBase: this.forecastAjstListData[i].totalForecastSum,
							});
						} else if (this.forecastAjstListData[i].removeAjestValue) {
							data.topdownAjst.push({
								period: this.forecastAjstListData[i].period,
								ajestValue: null,
								removeAjestValue: this.forecastAjstListData[i].removeAjestValue,
								SpiltBase: this.forecastAjstListData[i].totalForecastSum,
							});
						}
					} else {
						data.topdownAjst.push({
							period: this.forecastAjstListData[i].period,
							ajestValue: this.forecastAjstListData[i].ajestValue,
							removeAjestValue: this.forecastAjstListData[i].removeAjestValue,
							SpiltBase: this.forecastAjstListData[i].totalForecastSum,
						});
					}
				}
			}

			this.forecastService.AddUpdateAdjustmentDataNew(data).subscribe(
				(result) => {
					if (result != null) {
						if (result.flag > 0) {
							AppDevNotifyComponent.SuccesMessage(result.msg);
							this.searchData('');
							this.saveDataEvent.emit(true);
						} else {
							AppDevNotifyComponent.ErrorMessage(result.msg);
							this.searchData('');
						}
					} else {
						AppDevNotifyComponent.ErrorMessage('Sorry, Something went wrong. Please try after some time again.');
					}
				},
				(err) => {
					AppDevNotifyComponent.ErrorMessage('Sorry, something went wrong. Please try after some time again.');
				}
			);
		} else {
			AppDevNotifyComponent.ErrorMessage('Sorry, There is no data to be updated. Please try after some time again.');
		}
	}

	config = {
		name: '',
		disabled: false,
		height: 30,
		width: 100,
		margin: 2,
		fontSize: 11,
		speed: 300,
		color: {
			checked: '#ff5722',
			unchecked: '#ff5722',
		},
		switchColor: {
			checked: 'white',
			unchecked: 'white',
		},
		labels: {
			unchecked: 'Percentage',
			checked: 'Quantity',
		},
		checkedLabel: '',
		uncheckedLabel: '',
		fontColor: {
			checked: '#ffffff',
			unchecked: '#ffffff',
		},
	};

	OnQuantitychange() {
		this.forecastAjstListData.forEach((element) => {
			if (element.ajestValue) {
				element.ajestValue = null;
			}
		});
		this.checkedTopdown = !this.checkedTopdown;
		if (!this.checkedTopdown) {
			this.forecastAjstListData.forEach((element) => {
				if (element.totalTemplate) {
					element.totalTemplate = null;
				}
			});
			this.showTotalQuantity = !this.showTotalQuantity;
			this.numberFormat = '#,##0.##%';
			this.numberTitle = 'Quantity(%)';
		} else {
			this.showTotalQuantity = true;
			this.numberFormat = '#,##0.##';
			this.numberTitle = 'Quantity';
		}
	}

	public calculateAjestQuantity(item) {
		if (item) {
			if (!item.totalTemplate) {
				item.ajestValue = null;

				return;
			}

			if (item.totalForecastSum === 0) {
				item.ajestValue = item.totalTemplate;
			} else {
				item.ajestValue = item.totalTemplate - item.totalForecastSum;
			}
		}
	}

	public calculateTotalQuantity(item) {
		if (item) {
			if (!item.ajestValue) {
				item.totalTemplate = null;

				return;
			}

			item.totalTemplate = item.ajestValue + item.totalForecastSum;
		}
	}
}

import {DxDataGridModule, DxValidatorModule, DxSelectBoxComponent, DxRadioGroupModule, DxDateBoxModule, DxButtonModule, DxPopupModule, DxSelectBoxModule, DxCheckBoxModule, DxLoadPanelModule, DxNumberBoxModule, DxSwitchModule} from 'devextreme-angular';
import {CommonModule} from '@angular/common';
import {DevEpressCommonModule} from 'src/app/dev-epress-common.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ForecastAjstSplitBaseData, DdlData, TopdownAdjustmentParam, TopdownAddAdjustmentSelection, UpdateTopDown, TopdownAdjustmentParamNew} from 'src/app/models/forecast/topdown-adjustment.model';
import {ForecastService} from 'src/app/pages/forecast/forecast.service';
import {AppDevNotifyComponent} from '../dev-notify-bar/dev-notify-bar.component';
import {NgToggleModule} from 'ng-toggle-button';
import {ForecastChartCaption} from 'src/app/models/forecast/fc-overview-models';
import {NumberBoxComponent} from 'src/app/components/number-box/number-box/number-box.component';
@NgModule({
	declarations: [TopdownAdjustmentCommonComponent],
	exports: [TopdownAdjustmentCommonComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, NumberBoxComponent, DevEpressCommonModule, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxLoadPanelModule, DxNumberBoxModule, DxSwitchModule, NgToggleModule, DxDateBoxModule, DxButtonModule, DxPopupModule, DxValidatorModule, DxRadioGroupModule],
})
export class TopdownAdjustmentCommonModule {}
